// メッセージ機能の定数定義

export const SIZE_OPTIONS = ['小', '中', '大'] as const;
export const TEXT_COLOR_OPTIONS = ['白', '黄', '赤'] as const;
export const BG_COLOR_OPTIONS = ['黒', '赤'] as const;

export const SIZE_MAP = { '小': 'SMALL', '中': 'MEDIUM', '大': 'LARGE' } as const;
export const FONT_COLOR_MAP = { '白': '#FFFFFF', '黄': '#FFFF00', '赤': '#FF0000' } as const;
export const BACKGROUND_COLOR_MAP = { '黒': '#000000', '赤': '#FF0000' } as const;

// 逆マッピング
export const SIZE_REVERSE_MAP = { 'SMALL': '小', 'MEDIUM': '中', 'LARGE': '大' } as const;
export const FONT_COLOR_REVERSE_MAP = { '#FFFFFF': '白', '#FFFF00': '黄', '#FF0000': '赤' } as const;
export const BACKGROUND_COLOR_REVERSE_MAP = { '#000000': '黒', '#FF0000': '赤' } as const;

// URL検出の正規表現
export const URL_REGEX = /(https?:\/\/[^\s]+)/g;

// 文字数制限
export const MESSAGE_MAX_LENGTH = 256;
export const MESSAGE_WARNING_LENGTH = 230; 